import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<CustomApplicationActions>>;

export const DispatchClearPiyoviValidationResult: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCheckoutShipping/ClearPiyoviValidationResult",
    });
};

export const chain = [DispatchClearPiyoviValidationResult];

const clearPiyoviValidationResult = createHandlerChainRunner(chain, "ClearPiyoviValidationResult");
export default clearPiyoviValidationResult;
